import axios from 'axios';

const API=axios.create({baseURL:'https://indiangram.herokuapp.com/'})

API.interceptors.request.use((req)=>{
    if(localStorage.getItem('profile')){
        req.headers.Authorization=`Bearer ${JSON.parse(localStorage.getItem('profile')).token}`
    }

    return req;
})

export const fetchPosts=()=>API.get('/post');
export const createPost=(newPost)=>API.post('/post/createPost',newPost);
export const updatePost=(id,updatedPost)=>API.patch(`/post/${id}`,updatedPost)
export const deletePost=(id)=>API.delete(`/post/${id}`);
export const likePost=(id)=>API.patch(`/post/${id}/likePost`)

export const signin=(formData)=>API.post('/user/signin',formData);
export const signup=(formData)=>API.post(`/user/signup`,formData);
export const Userlist=()=>API.get('/user');
